import React from "react";
import {
  KG_INSPECTOR_ICON_DEFAULT_SIZE,
  kgInspectorIcons,
} from "../../kg/canvas/inspector/kgInspectorIcons";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import { KgInspectorDetailRow } from "../KgInspectorDetailRow";
import {
  ColumnsGridWrap,
  BodyEmptyHint,
  EmptyHint,
  FormulaExpression,
  Section,
  SectionBody,
  TabRoot,
} from "./KgInspectorMetricFormulaTab.styles";
import type { KgInspectorMetricFormulaTabProps } from "./KgInspectorMetricFormulaTab.types";

const FormulaIcon = kgInspectorIcons.formula;
const ColumnsIcon = kgInspectorIcons.columns;
const formulaIconSize = KG_INSPECTOR_ICON_DEFAULT_SIZE.formula;
const columnsIconSize = KG_INSPECTOR_ICON_DEFAULT_SIZE.columns;

export const KgInspectorMetricFormulaTab: React.FC<
  KgInspectorMetricFormulaTabProps
> = ({
  formula,
  isFormulaOpen = false,
  isColumnsOpen = false,
  onToggleFormula,
  onToggleColumns,
}) => {
  const expression = formula?.expression ?? "";
  const columns = formula?.columns ?? [];

  return (
    <TabRoot>
      <Section>
        <KgInspectorDetailRow
          icon={<FormulaIcon size={formulaIconSize} />}
          label="Formula"
          onToggle={onToggleFormula}
          isOpen={isFormulaOpen}
        />
        {isFormulaOpen && (
          <SectionBody>
            {expression ? (
              <FormulaExpression>{expression}</FormulaExpression>
            ) : (
              <BodyEmptyHint>No formula defined for this metric yet.</BodyEmptyHint>
            )}
          </SectionBody>
        )}
      </Section>

      <Section>
        <KgInspectorDetailRow
          icon={<ColumnsIcon size={columnsIconSize} />}
          label="Associated columns"
          badge={columns.length > 0 ? columns.length : undefined}
          onToggle={onToggleColumns}
          isOpen={isColumnsOpen}
        />
        {isColumnsOpen && columns.length > 0 && (
          <ColumnsGridWrap>
            <KgInspectorDataGrid
              rows={columns}
              rowKey={(column) => column.id}
              columns={[
                {
                  key: "columnName",
                  header: "COLUMN",
                  width: "flex",
                  render: (column) => column.columnName,
                },
                {
                  key: "tableName",
                  header: "TABLE",
                  width: "flex",
                  render: (column) => column.tableName,
                },
                {
                  key: "dataSourceName",
                  header: "DATA SOURCE",
                  width: "flex",
                  render: (column) => column.dataSourceName,
                },
              ]}
            />
          </ColumnsGridWrap>
        )}
        {isColumnsOpen && columns.length === 0 && (
          <EmptyHint>No columns associated with this metric yet.</EmptyHint>
        )}
      </Section>
    </TabRoot>
  );
};

export default KgInspectorMetricFormulaTab;
